import { __assign } from "tslib";
import React, { useContext } from 'react';
import { CenteredLoader } from '../components/centered-loader';
export var ResourcesCTX = React.createContext({});
export var suspendable = function (Component) {
    return function (props) { return (React.createElement(React.Suspense, { fallback: React.createElement(CenteredLoader, null) },
        React.createElement(Component, __assign({}, props)))); };
};
export var useResource = function (resourceFetcher, resourceId) {
    var resources = useContext(ResourcesCTX);
    if (!resources[resourceId]) {
        resources[resourceId] = { status: 'pre-fetch' };
    }
    if (resources[resourceId].status === 'fetch-fulfilled') {
        return resources[resourceId].data;
    }
    var promise = resourceFetcher()
        .then(function (res) {
        resources[resourceId].status = 'fetch-fulfilled';
        resources[resourceId].data = res;
    })
        .catch(function () {
        resources[resourceId].status = 'fetch-fulfilled';
    });
    throw promise;
};
//# sourceMappingURL=use-resource.js.map